import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import Breadcrumb from "./../shared/breadcrumbs";
import { HeroImage } from "../shared/hero-image";
import { Icon } from "../../../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import appExclusive from "../../../../../../assets/images/app-exclusive.png";
import { GA } from "../../../../../integrations";

import styles from "./styles.m.css";

function AppStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const StoryUrl = get(props, ["story", "url"], () => null);
  const Atitle = get(props, ["story", "headline"], null);
  const renderHeaderPhoto = () => <HeroImage story={props.story} />;

  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const Storycard = get(props, ["story", "cards"], () => null);

  const handleClickEvent = view => {
    const storyHeadline = get(this.props, ["story", "headline"], null);
    GA.customEvent("app-exclusive", `Clicked`, storyHeadline);
  };

  // eslint-disable-next-line max-len
  let openLinkUrl = `https://vikatanapp.page.link/?link=${StoryUrl}&apn=com.vikatanapp&isi=452698974&ibi=com.vikatan.reader&ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&utm_campaign=AppExclusiveArticles&utm_medium=Website&utm_source=${Atitle}&efr=1`;
  let userAgent = "";
  if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
    userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
  }

  return (
    <div className="page-content">
      <div className={`container ${styles.breadcrumb}`}>
        <Breadcrumb subSection={section} config={props.config} />
      </div>
      <div className={`container ${styles["story-grid"]}`}>
        <div className={`${styles["main-content"]}`}>
          <article className={`${styles["story-body"]} js-story`}>
            {renderHeaderCard({ className: styles["story-header"] })}
            {renderHeaderPhoto()}
            <div className={`${styles["app-exclusive-tag"]}`}>
              <img alt="Vikatan" src={assetify(appExclusive)} width="181px" height="35px" />
            </div>
            {renderSocialMedia()}
            <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
            <div className="content-section">
              {Storycard.map((card, index) => {
                if (index === 0)
                  return (
                    <React.Fragment key={card.id}>
                      <StoryCard card={card} story={props.story} />
                    </React.Fragment>
                  );
              })}
            </div>
            <div className={`${styles["app-exclusive"]}`}>
              <div className={`${styles["app-header"]}`}>
                <Icon type="app-exclusive" className={styles["exclusive-icon"]} />

                <h3>இது ஓர் ஆப் எக்ஸ்க்ளூசிவ் படைப்பு!</h3>
              </div>
              <div className={`${styles["app-desc"]}`} onClick={() => handleClickEvent(userAgent)}>
                <p>
                  நீங்கள் விகடன் ஆப் பயன்படுத்துபவர் என்றால் கீழே க்ளிக் செய்து இதை App-ல் வாசிக்கலாம். இல்லை எனில்,
                  விகடன் ஆப் இன்ஸ்டால் செய்யவும்.
                </p>
                <p>
                  முதல்முறையாக ஆப் ரிஜிஸ்டர் செய்பவர்கள் அனைத்து விகடன் இதழ்களையும் விளம்பரங்களின்றி இலவசமாக
                  வாசிக்கலாம்.
                </p>

                <a href={openLinkUrl} className={`${styles["app-link"]}`}>
                  READ IN APP
                </a>
              </div>
            </div>
          </article>
        </div>
        {renderSidebar(false)}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
AppStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { AppStory };
